// extracted by mini-css-extract-plugin
export default {"wrapper":"status-badge_wrapper__Edd5L"};